import React, { useState } from "react";
import { Navbar } from "flowbite-react";
import { cvPageUrl } from "../constants";

const Header = () => {
  const [activeLink, setActiveLink] = useState("#hello");

  const handleLinkClick = (link) => {
    setActiveLink(link);
  };

  return (
    <Navbar
      fluid
      className="fixed top-0 left-0 right-0 z-50 bg-darkblue p-6 md:px-16"
    >
      <Navbar.Brand>
        <span className="whitespace-nowrap font-semibold text-white">
          tomas-oles
        </span>
      </Navbar.Brand>
      <Navbar.Toggle />
      <Navbar.Collapse className="bg-darkblue">
        <Navbar.Link
          href="#hello"
          className={`${activeLink === "#hello" ? "border-b-2 border-white" : ""} text-white hover:text-white hover:bg-transparent hover:border-b-2 hover:border-white`}
          onClick={() => handleLinkClick("#hello")}
        >
          _hello
        </Navbar.Link>
        <Navbar.Link
          href="#selected_publications"
          className={`${activeLink === "#selected_publications" ? "border-b-2 border-white" : ""} text-white hover:text-white hover:bg-transparent hover:border-b-2 hover:border-white`}
          onClick={() => handleLinkClick("#selected_publications")}
        >
          _selected publications
        </Navbar.Link>
        <Navbar.Link
          href="#work_in_progress"
          className={`${activeLink === "#work_in_progress" ? "border-b-2 border-white" : ""} text-white hover:text-white hover:bg-transparent hover:border-b-2 hover:border-white`}
          onClick={() => handleLinkClick("#work_in_progress")}
        >
          _work in progress
        </Navbar.Link>
        <Navbar.Link
          href={cvPageUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-white hover:text-white hover:bg-transparent hover:border-b-2 hover:border-white"
        >
          _cv
        </Navbar.Link>
        <Navbar.Link
          href="#contact"
          className={`${activeLink === "#contact" ? "border-b-2 border-white" : ""} text-white hover:text-white hover:bg-transparent hover:border-b-2 hover:border-white`}
          onClick={() => handleLinkClick("#contact")}
        >
          _contact
        </Navbar.Link>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default Header;